export default [{
        path: '/animation-commerciale/produits',
        name: 'produits-list',
        component: () => import('@/views/assureur/animation-commerciale/produits/Lists.vue'),
    },
    {
        path: '/animation-commerciale/assureur',
        name: 'assureur-profile',
        component: () => import('@/views/assureur/animation-commerciale/assureur/IndexAssureur.vue'),
    },
]